import type { QueryKey } from '@tanstack/react-query';

import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import type { AssignableRolesResponse } from '../../../../shared/model-typings';

//  Actual function to fetch assignable roles.
//  Note that this endpoint returns Roles with permissions (for whatever reason).
function fetchAssignableRoles() {
  return get<AssignableRolesResponse>('/api/roles/assignable');
}

/**
 * This is used by react-query for caching and invalidation.
 * This can contain anything (including objects like filters)
 * that can be used to uniquely identify the query.
 */
const queryKey: QueryKey = ['assignableRoles'];

/**
 * useAssignableRoles is a hook that fetches and returns the roles that the
 * current user is able to assign to other users from /api/roles/assignable.
 */
export default function useAssignableRoles() {
  return useQuery<AssignableRolesResponse>({
    queryKey,
    queryFn: fetchAssignableRoles,
    //  Roles don't change *that* often, so we can cache them for a while to improve performance.
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
